import React, { Suspense } from 'react';
import lazyImport from 'utils/lazyImport';

import BusinessCardPage from 'features/labs/routes/BusinessCardPage';
import { Loader } from '@urbantxt/loader';

const { AuthRoutes } = lazyImport(
  () => import('features/auth'),
  'AuthRoutes',
);

const publicRoutes = [
  {
    path: '/*',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <AuthRoutes />
      </Suspense>
    ),
  },
  {
    path: '/business-cards',
    element: (
      <Suspense fallback={<Loader theme="dark" isVisible fullscreen />}>
        <BusinessCardPage />
      </Suspense>
    ),
  },
];

export default publicRoutes;
